export interface IClientStorageOptions {
  storageTime?: number;
}

abstract class ClientStorage {
  private readonly storageTime: number;

  constructor(options?: IClientStorageOptions) {
    this.storageTime = options?.storageTime || 7776000000; // 90 days;
  }

  public saveToClientSession = (key: string, data: any) => {
    window.localStorage.removeItem(key);
    window.sessionStorage.setItem(key, JSON.stringify(data));
  };

  public saveToClientStorage = (
    key: string,
    data: any,
    storageTime?: number
  ) => {
    window.sessionStorage.removeItem(key);
    window.localStorage.setItem(
      key,
      JSON.stringify({
        expires: Date.now() + (storageTime || this.storageTime),
        data,
      })
    );
  };

  public readFromClientSession = (key: string) => {
    const dataRaw = window.sessionStorage.getItem(key);
    if (dataRaw === null) {
      return dataRaw;
    }
    let data: any;
    try {
      data = JSON.parse(dataRaw);
    } catch (e) {
      window.sessionStorage.removeItem(key);
      data = null;
    }
    return data;
  };

  public readFromClientStorage = (key: string) => {
    const dataRaw = window.localStorage.getItem(key);
    if (dataRaw === null) {
      return dataRaw;
    }
    let data: any;
    try {
      const dataObj = JSON.parse(dataRaw);
      if (dataObj.expires > Date.now()) {
        data = dataObj.data;
      } else {
        throw new Error('Data expired!');
      }
    } catch (e) {
      window.localStorage.removeItem(key);
      data = null;
    }
    return data;
  };

  public getStoredItem = (key: string) => {
    return this.readFromClientSession(key) || this.readFromClientStorage(key);
  };

  public removeStoredItem = (key: string) => {
    window.sessionStorage.removeItem(key);
    window.localStorage.removeItem(key);
  };
}

export default ClientStorage;
